<script setup lang="ts">
import { pb } from "@/pocketbase";
import Title from "@/components/Title.vue";
import LinkBox from "@/components/LinkBox.vue";
import Heading from "@/components/Heading.vue";
import Divider from "@/components/Divider.vue";
import Content from "@/components/Content.vue";

const user: { name: string } = pb.authStore.model;

</script>

<template>
  <Title :subtitle="user.name">Hi there,</Title>
  <Divider/>
  <Content>
    <p>
      You are browsing the <b>TSG R&amp;D Collaboration Hub</b>, a dedicated place for promoting
      collaboration and innovation between companies and business units within the TSG
      (<a class="default-anchor" href="https://tourismsoftwaregroup.com/" target="_blank">Tourism Software Group</a>).
    </p>

    <div class="grid lg:grid-cols-2 gap-2 lg:gap-5">
      <LinkBox route="business_units" title="Business Units" description="Overview of all TSG business units and their products"/>
      <LinkBox route="tech_landscape" title="Tech Landscape" description="Browse tech stacks used by TSG companies and business units"/>
      <LinkBox route="events" title="Events" description="Overview of future and past events"/>
      <LinkBox route="resources" title="Resources" description="References to resources with relevance to all TSG companies and business units"/>
    </div>

    <Heading>Other things</Heading>

    <div class="grid lg:grid-cols-3 gap-2 lg:gap-5">
      <LinkBox url="mailto:philippe@payyo.ch" title="Feedback" description="If you have suggestions, questions or general feedback, please reach out and help shape this place."/>
      <LinkBox url="https://github.com/trekksoftgroup/collabhub" title="Contribute" description="This project is available on GitHub. All contributions are welcomed."/>
    </div>
  </Content>
</template>

